export default function NotFound() {
    return (
        <div style={{minHeight: "85vh", textAlign: "center", display: "flex", flexFlow: "column", alignItems: "center", justifyContent: "center"}}>
            <h1>404 Page not found</h1>
            <p>asdfghjklpoiuytrewsxcvbnm,lkiuytresxcvbnkjtgrfdsxdjkl,</p>
        </div>
    )
}